import { FaFacebookF, FaLinkedinIn, FaTwitter, FaYoutube, FaUser, FaInstagram } from 'react-icons/fa';
import { useEffect } from 'react';
import { useFileContext } from "../../../Contexts/FileContext"; 
import { WebApiURL } from '../../../Constants/Constants';
function ManagementTeamBODTab() {
  
   const { employees, setEmpComponentName } = useFileContext();

  useEffect(() => {
    setEmpComponentName('BOARD OF DIRECTORS'); 
  }, []);

  return (
    <>
      {employees?.map((card, index) => (
        <div className="col-lg-3 col-md-6 col-6" key={index}>
          <div className="latest-marine-card w-100">
            <div className="card-img mb-3 rounded-2 overflow-hidden">
              <img src={`${WebApiURL}File/ViewEmp/${encodeURIComponent(card?.empId)}`}
                alt={card?.imageFileName} className="img-fluid w-100" />
              {/* <div className="card-share">
                <a href="#" className="btn-share">
                  <i className="bi bi-share"></i>
                </a>
                <ul>
                  <li>
                    <a href="#">
                      <FaFacebookF />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <FaTwitter />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <FaLinkedinIn />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <FaInstagram />
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <FaYoutube />
                    </a>
                  </li>
                </ul>
              </div> */}
            </div>

            <h4 className="title mt-3 text-wrap text-center font-20 font-600">
              {card?.empName}{" "}
            </h4>
            <p className="title text-wrap text-center font-18 font-600 text-green-38B652">
              {card?.designation}
            </p>
          </div>
        </div>
      ))}
    </>
  );
}

export default ManagementTeamBODTab;
